import { render, staticRenderFns } from "./authNavbar.vue?vue&type=template&id=4845db7e&"
import script from "./authNavbar.vue?vue&type=script&lang=js&"
export * from "./authNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports